// Provides a button to click to clear video cache on next reload

import React, { useState, FC, useContext } from 'react'
import { observer } from 'mobx-react'
import { t } from 'ttag'
import _debug from 'debug'
import { RootContext } from '../app/RootContext'
import { CLEAR_VIDEO_CACHE, CLEAR_VIDEO_CACHE_INSTRUCTIONS_1, CLEAR_VIDEO_CACHE_INSTRUCTIONS_2 } from '../../models3/VideoCache.utils'

const log = _debug('sltt:VideoCacheResetRequest')

interface IVideoCacheResetRequest {
}

const VideoCacheResetRequest: FC<IVideoCacheResetRequest> = observer(() => {
    const [showReloadMessage, setShowReloadMessage] = useState(false)
    const rt = useContext(RootContext)

    const requestReset = () => {
        localStorage.setItem('cacheResetRequest', 'YES')
        setShowReloadMessage(true)
    }

    if (showReloadMessage) {
        return (<>
            <div>{CLEAR_VIDEO_CACHE_INSTRUCTIONS_1}</div>
            <div>{CLEAR_VIDEO_CACHE_INSTRUCTIONS_2}</div>
        </>)
    }

    return (
        <div>
            <button type="button"
                className={"btn btn-default"}
                onClick={requestReset}>{CLEAR_VIDEO_CACHE}</button>
        </div> 
    )
})

export default VideoCacheResetRequest